import React from 'react';

import { Environment } from 'app/common/services';

function useContentInfo() {
  return React.useMemo(
    () => ({
      browseContentItemEndpoint: Environment.get(
        'BROWSE_CONTENT_ITEM_ENDPOINT',
        'catalog-browse/browse/content-items'
      ),
      aboutUsModelName: Environment.get('MODEL_ABOUT_US', 'About Us'),
      guestHomeModelName: Environment.get('MODEL_GUEST_HOME', 'Guest Home'),
      termsOfUseModelName: Environment.get(
        'MODEL_TERMS_OF_USE',
        'Terms of Use'
      ),
      privacyPolicyModelName: Environment.get(
        'MODEL_PRIVACY_POLICY',
        'Privacy Policy'
      ),
      maintenanceBannerModelName: Environment.get(
        'MODEL_MAINTENANCE_BANNER',
        'Maintenance Banner'
      ),
      contactUsModelName: Environment.get('MODEL_CONTACT_US', 'Contact Us'),
      sortPrefsModelName: Environment.get(
        'MODEL_SORT_PREFS',
        'Preferred Product Sort'
      ),
      inventoryMessagingModel: Environment.get(
        'MODEL_INVENTORY_MESSAGING',
        'Inventory Messaging'
      ),
      payInStoreMessagesModel: Environment.get(
        'MODEL_PAYINSTORE_MESSAGES',
        'Pay in Store Messages'
      )
    }),
    []
  );
}

export default useContentInfo;
